import React from 'react';
import PropTypes from 'prop-types';

import './index.css';
import { withStyles } from '@material-ui/core/styles';
import { FDLozenge } from '@facet-wealth/design';

const styles = {
};

const HouseholdTag = ({
  tagResource,
}) => (
  <FDLozenge status={tagResource.attr('status')} color={tagResource.attr('status')} label={tagResource.attr('name')} />
);

HouseholdTag.propTypes = {
  tagResource: PropTypes.object.isRequired,
};

HouseholdTag.defaultProps = {
};

export default withStyles(styles)(HouseholdTag);
